import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Nav, Tab } from 'react-bootstrap';
import PassingCriteriaPage from './PassingCriteriaPage'; 
import CertificatePage from './CertificatePage'; 
import axios from 'axios';
import { getUserCertificate } from '../../../utils/useWindowDimensions';
import { saveCertificate } from '../../../store/slice/userSlice';


const  ConfigurationPage = () => {
    const configData = useSelector(state => state.configSlice);
    let MODE = configData.config.MODE;
    const userData = useSelector(state => state.userSlice);
    const [activeKey, setActiveKey] = useState('');
    const dispatch = useDispatch();
    const [certificateConfig, setCertificateConfig] = useState(null);
    const [list, setList] = useState([]);
    const [listLoading, setListLoading] = useState(true);

    const getGroupCertificateDetails = async() =>{
        try {

          let _certificate= await getUserCertificate(configData.config.UNO_URL, userData.token, MODE);
          setCertificateConfig(_certificate);
        } catch (error) {
            console.log(error);
        }
    }

    const getModuleList = async () => {
      try {
          const resData = await axios.get(`${configData.config.API_URL}/api/module/list/passing/criteria/${MODE}`, {
              headers: {
                  Authorization: `Bearer ${userData.token}`,
              }
          });
          let moduleList = resData?.data?.data || [];
          setList([...moduleList]);
          setListLoading(false);
      } catch (error) {
          console.log(error);
      }
    }

    useEffect(()=>{
        // if(userData.user.permissions.includes("XR.CONFIGURATION.UPDATE")){
        if(["XR.CONFIGURATION.UPDATE", "SKILL.STREAM.CONFIGURATION.UPDATE"].some(permission => userData.user.permissions.includes(permission))){
            setActiveKey("certificate");
        } else if(MODE == "XR" && userData.user.permissions.includes("XR.PASSINGCRITERIA.UPDATE")){
            setActiveKey("criteria");
        }

        // if(userData.user.permissions.includes("XR.CONFIGURATION.UPDATE")){
        if(["XR.CONFIGURATION.UPDATE", "SKILL.STREAM.CONFIGURATION.UPDATE"].some(permission => userData.user.permissions.includes(permission))){
            getGroupCertificateDetails();
        }
        if(MODE == "XR" && userData.user.permissions.includes("XR.PASSINGCRITERIA.UPDATE")){
            getModuleList();
        }


    },[userData]);

    const handleTabChange = (newActiveKey) => {
        setActiveKey(newActiveKey);
      };

  return (
    <>
      <Tab.Container activeKey={activeKey} onSelect={handleTabChange}>
        <Nav className='tabsproduct updated toptab' variant="pills">
          
        
          {/* {userData.user.permissions.includes("XR.CONFIGURATION.UPDATE") && <Nav.Item> */}
          {["XR.CONFIGURATION.UPDATE", "SKILL.STREAM.CONFIGURATION.UPDATE"].some(permission => userData.user.permissions.includes(permission)) && <Nav.Item>
            <Nav.Link eventKey="certificate">Certificates</Nav.Link>
          </Nav.Item>}

          { MODE == "XR" && userData.user.permissions.includes("XR.PASSINGCRITERIA.UPDATE") &&  <Nav.Item>
            <Nav.Link eventKey="criteria">Passing Criteria</Nav.Link>
          </Nav.Item>}

        </Nav>

        <div className='container-fluid p-2 px-3 bg-grey-main'>
          <Tab.Content className='mt-5 ps-2'>

            <Tab.Pane eventKey="certificate">
              <CertificatePage certificateConfig={certificateConfig} getGroupCertificateDetails={getGroupCertificateDetails} />
            </Tab.Pane>

            <Tab.Pane eventKey="criteria">
              <PassingCriteriaPage listLoading={listLoading} list={list} />              
            </Tab.Pane>

          </Tab.Content>
        </div>
      </Tab.Container>
    </>
  );
};

export default ConfigurationPage;
